import { Component, ElementRef,EventEmitter, Input,Output, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { clearError, processTextField, submitForm, trcQuest } from 'app/shared/Validator/TRCFastQues.validator';
import { Answer } from 'app/shared/models/Answer.model';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { QuesDetails } from 'app/shared/models/quesDetails.model';
import { MeasureStruct } from 'app/shared/models/measureStruct.model';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { autoTabWithDash2, autoTabWithDash } from 'app/core/util/autodash';

@Component({
    selector: 'jhi-eappreg-fasttrack',
    templateUrl: './eappreg-fasttrack.component.html',
    styleUrls: ['./eappreg-fasttrack.component.scss']
})
export class EappregFastTrackComponent implements OnInit {
    parentArray: string[] = []
          
@Output() answerAdded: EventEmitter<Answer[]> = new EventEmitter<Answer[]>();

   answers: Answer[] = []    
   FastTrackGrpRow = 5
	DupEntryGrpRow = 0

	currrLvl = "2";  
    DispOnlyInd = "N"
    DispSeqIndY = "Y"
    DispSeqIndN = "N"
    DispSeqType = "A"
    TRCCurrLevel = 1   

    qQuestions: Questionnaire[] = []
    fForm = this.fb.group({})
    formObjArray: any[] = []

    qQuestions1 : Questionnaire[] = []   

    TRCQForms: Answer[] =[]
    TRCQGroups = sessionStorage.getItem("TRCQGroups") ? JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "") : "[]"
    trcAppForm = sessionStorage.getItem("TRCAppForm") ? JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "") : "{}"
    
    systemDate = ""
    errorExist = false
    errorMessage = ""
    isqQuestionsReadOnly = false;
    isDisable :any
    isDisable1 :any
    grpId :any
    isDisable2=false;
    isDisabledValue=true;
	nonQuestValue =""

	trcNextSteps: TRCNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "{}");
	tempMsg: any;	
	qDetails: QuesDetails[] = [];
	measureStruct: MeasureStruct[] = [];
	tRCFundClasses: TRCFundClasses[] = []
	errEist = false;
	eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
	secondaryQuestions : any
    ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
    };
              

    constructor(private fb: FormBuilder, private _businessService: BussinessRegAppService, 
        private router: Router, private modalService: NgbModal, private route: ActivatedRoute,
        private el: ElementRef) {
            history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
                history.go(1);
            };                       
        this.qQuestions = this.route.snapshot.data["busVerificationQuestions"]                  
        sessionStorage.setItem("TRCCurrGrpMetaName", "FASTTRACKGRP"),       
        this.qQuestions1 = this.route.snapshot.data["fastTracklevel1Questions"]     
      }
   
ngOnInit(): void {	
	
        const temp = "eappreg"
		sessionStorage.setItem("TRCFastTrackGrpId",'');
        if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_criteria"){
            sessionStorage.setItem("TRCCurrentPage","eappreg_fasttrack") ;
        }
       
        else if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_confirm" ||sessionStorage.getItem("TRCCurrentPage") === "eappreg_questionnaire" ||
                sessionStorage.getItem("TRCCurrentPage") === "eappreg_app" ||sessionStorage.getItem("TRCCurrentPage") === "eappreg_business_questions"){
                        sessionStorage.setItem("TRCCurrentPage","eappreg_fasttrack") ;
        } if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_fasttrack"){
            sessionStorage.setItem("TRCQForms", "[]");
        }else{
            //Didn't come from right program so call error routine.
            this.router.navigate(['error-page'])
        }
 
    }

 submit(): void { 
			this.fForm.markAllAsTouched();
			
			if (submitForm(this.fForm, this.modalService)) {
			
            for (const key of Object.keys(this.fForm.controls)) {
				if(this.isDisable===false && (key!=='SSN' && key!=='FEIN')){
					this.fForm.controls[key].setValue("")
				}
				
                if (this.fForm.controls[key].invalid) {
                  const invalidControl = this.el.nativeElement.querySelector('[name="' + key + '"]');
                  invalidControl.focus();
                  break;
                }
            }
            this.grpId=sessionStorage.getItem("TRCFastTrackGrpId")??""			            
            this.formObjArray = []
            Object.keys(this.fForm.value).forEach((elem)=>{
				this.TRCQForms = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]")
                const qId = this.TRCQForms.find((ans:Answer)=>ans.metaName === elem)
                const answerObj = new Answer();
                answerObj.answerTxt = this.fForm.get(elem)?.value
                answerObj.questionId = qId !== undefined ? qId.questionId:0
                answerObj.metaName = elem
                
 
	
                this.formObjArray.push(answerObj)
            })
            //  update TRCQForm session data with latest selections
            this._businessService.updateTrcSessionForm({
                "trcFormData": this.formObjArray,
                "trcSessionData": this.TRCQForms,
                "qGrpID": sessionStorage.getItem("TRCFastTrackGrpId")??""
            }).subscribe((res: any) => {
                this.TRCQForms = res
                sessionStorage.setItem("TRCQForms", JSON.stringify(res))
				
				this.eappreg_fasttrack_action();
            })
			
                 
				
}

			else{
            trcQuest(this.fForm)
            for (const key of Object.keys(this.fForm.controls)) {
                if (this.fForm.controls[key].invalid) {
                  const invalidControl = this.el.nativeElement.querySelector('[name="' + key + '"]');
					
                  invalidControl.focus();
				
                  break;
				
                }
            }
}
        
                  
				
			    
    }

eappreg_fasttrack_action(): void {	
        this.errorExist = false
        this._businessService.getSystemDate().subscribe((res: string) => {        
    this.trcAppForm.postMarkDt = new  Date(res);  
           sessionStorage.setItem("TRCAppForm", JSON.stringify(this.trcAppForm)) 
                       
        }) 
		const ssn = this.fForm.get("SSN")?.value
        const fein = this.fForm.get("FEIN")?.value
		this.nonQuestValue = this.fForm.get("NA")?.value
        
		sessionStorage.setItem("FEIN",fein);
        if (fein.length > 0) {
            this._businessService.getLATAXFEINCnt(fein.split("-").join("")).subscribe((feinRes: any) => {
                if(feinRes.alertMsg !== undefined){
                    const title = "Confirmation"
                    const body = feinRes.alertMsg
                    const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                    modalRef.componentInstance.cModalTitle = title
                    modalRef.componentInstance.cModalBody = body
                    modalRef.result.then((userResponse) => {
                        if (userResponse === "OK") {
                            this.router.navigate(['eappreg_criteria'])
                        }
                    });
                } else {
                const feinQId = this.TRCQForms.find(obj => obj.metaName === "FEIN")
                this._businessService.getWebAnswerCnt(feinQId !== undefined ? feinQId.questionId : 0, fein.split("-").join("")).subscribe((res: any) => {
                    if (res.alertMsg === undefined ) {
						
						
						if(this.grpId==="" || this.grpId===undefined){
							const title = "Confirmation"
      						const body = "Please answer the Business Activity question and select one of the 5 Business Activity options."
      						const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      						modalRef.componentInstance.cModalTitle = title
      						modalRef.componentInstance.cModalBody = body
      						modalRef.result.then((userResponse) => {
        					if (userResponse === "OK") {
          						this.router.navigate(['/eappreg_fasttrack']);
								
        			}
      				});
						}
						else if(this.nonQuestValue === "Y"){
							this.router.navigate(['/eappreg_questionnaire'], { state: { SSN: this.fForm.get("SSN")?.value,FEIN: this.fForm.get("FEIN")?.value } });
						}
						
						else{
						this.initialVariables();
						this.setUpBusinessFundClass();
						}
                    } else {
                        const title = "Confirmation"
                        const body = res.alertMsg
                        const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                        modalRef.componentInstance.cModalTitle = title
                        modalRef.componentInstance.cModalBody = body
                        modalRef.result.then((userResponse) => {
                            if (userResponse === "OK") {
                                this.router.navigate(['eappreg_criteria'])
                            }
                        });
                    }
                })
                }
            })
        } else if (ssn.length > 0) {
            this._businessService.getLATAXSSNCnt(ssn.split("-").join("")).subscribe((ssnRes: any) => {
                if(ssnRes.alertMsg !== undefined){
                    const title = "Confirmation"
                    const body = ssnRes.alertMsg
                    const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                    modalRef.componentInstance.cModalTitle = title
                    modalRef.componentInstance.cModalBody = body
                    modalRef.result.then((userResponse) => {
                        if (userResponse === "OK") {
                            this.router.navigate(['eappreg_criteria'])
                        }
                    });
                }else{
                    const ssnQId = this.TRCQForms.find(obj => obj.metaName === "SSN")
                this._businessService.getWebAnswerCnt(ssnQId !== undefined ? ssnQId.questionId : 0, ssn.split("-").join("")).subscribe((res: any) => {
                    if (res.alertMsg === undefined ) {
						
						
						if(this.grpId==="" || this.grpId===undefined){
							const title = "Confirmation"
      						const body = "Please answer the Business Activity question and select one of the 5 Business Activity options."
      						const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      						modalRef.componentInstance.cModalTitle = title
      						modalRef.componentInstance.cModalBody = body
      						modalRef.result.then((userResponse) => {
        					if (userResponse === "OK") {
          						this.router.navigate(['/eappreg_fasttrack']);
								
        			}
      				});
						}
						
						else if(this.nonQuestValue === "Y"){
							this.router.navigate(['/eappreg_questionnaire'], { state: { SSN: this.fForm.get("SSN")?.value,FEIN: this.fForm.get("FEIN")?.value } });
						}
						
						else{
							this.initialVariables();
						this.setUpBusinessFundClass();
						}
						
                        
                         
                    } else {
                        const title = "Confirmation"
                        const body = res.alertMsg
                        const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                        modalRef.componentInstance.cModalTitle = title
                        modalRef.componentInstance.cModalBody = body
                        modalRef.result.then((userResponse) => {
                            if (userResponse === "OK") {
                                this.router.navigate(['eappreg_criteria'])
                            }
                        });
                    }
                })
                } 
            })
        }           
    }
    
    update(answers: Answer[]): void {
        // this.TRCQForms = [...this.TRCQForms,...answers];
        for(let i=0;i<answers.length;i++){
            if(!this.TRCQForms.find(ansObj => ansObj.questionId === answers[i].questionId)){
                this.TRCQForms.push(answers[i])

            }
        }
        sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
this.data();
      }

	isFTYes(question: Answer, event: any): void {
		const fundclIndex = this.answers.findIndex(obj => obj.metaName === question.metaName)
		
		if(question.metaName === 'FASTTRACKGRP' ){
			if(event.target.value === 'N'){
				this.isDisable2=true
				this.jumpToNxtPagee();
			
			}
			else if(event.target.value === 'Y'){
				this.isDisable2=false
				this.isDisabledValue=false
				
			}
		}
		}
		
		jumpToNxtPagee(): void {
    

      const title = "Confirmation"

      const body = "You have answered that you are registering for more than one Business Activity.  You will now be redirected to the Questionnaire page."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_questionnaire'], { state: { SSN: this.fForm.get("SSN")?.value,FEIN: this.fForm.get("FEIN")?.value } });
        }
      });
    }
		
		
	isNotDisable():void{
		if(this.isDisable2===true){
			this.isDisabledValue=true
		}
		else{
			this.isDisabledValue=false
		}
	}
		
		
	

isBlock(a:boolean):void{
	if(a===true){
		this.isDisable=true
		this.isDisable1=true
	}
	else{
		this.isDisable=false
		
	}
}

isBlock1(a:boolean):void{
	if(a===true){
		this.isDisable1=true
	}
	else{
		this.isDisable1=false
		this.isDisable=true
		
	}
}






data(): void {

    const inputElem: any = document.getElementById("level1_table")?.getElementsByTagName("input");

    for (let i = 0; i < inputElem?.length; i++) {
      if (inputElem[i].type === 'radio') {
        (<HTMLElement>inputElem[i]).addEventListener('click', () => {
          clearError(inputElem[i]);
        });
      }
	if (inputElem[i].type === 'text') {
        (<HTMLElement>inputElem[i]).addEventListener('change', () => {
          processTextField(inputElem[i], this.modalService);
        })
      }      
    }
  }

ngAfterViewInit(): void {
        const inputElem: any = document.getElementById("DUPENTRYGRP")?.getElementsByTagName("input");
        const inputElem2: any = document.getElementById("FASTTRACKGRP")?.getElementsByTagName("input");
        
        for (let i = 0; i < inputElem.length; i++) {
            (<HTMLElement>inputElem[i]).addEventListener('change', () => {
                trcQuest(this.fForm)
            });
            (<HTMLElement>inputElem[i]).addEventListener('keyup', () => {
                this.autodash(event, inputElem[i].name)
            });
        }
		for (let i = 0; i < inputElem2.length; i++) {
            (<HTMLElement>inputElem2[i]).addEventListener('click', () => {
                clearError(inputElem2[i]);
            })
        }
        
    }

    autodash(event: any, name: string): void {
        if (name === "SSN") {
            autoTabWithDash2(event.target, event.target.maxLength, 3, 6, event)
        } else if (name === "FEIN") {
            autoTabWithDash(event.target, event.target.maxLength, 2, event)
        }
    }

isNumber(n: any): boolean {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }

    scrollToError(): void {
        const elementPosition = Number(document.getElementById('alertRef')?.offsetTop);
        window.scrollTo({
          top: elementPosition - 40,
          behavior: "smooth"
        });
      }


    get sessionStorage(): any {
        return sessionStorage;
    }

    initialVariables(): void {

    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
    this.tempMsg = sessionStorage.setItem("TRCDataErrors", "");
    //sessionStorage.removeItem("TRCDataErrors") ;

    //always create a new list at this point
    if (sessionStorage.getItem("TRCFundClasses")) {

      sessionStorage.removeItem("TRCFundClasses")
      const tRCFundClasses = new TRCFundClasses()
      sessionStorage.setItem("TRCFundClasses", JSON.stringify(tRCFundClasses))

    }          
  }
 setUpBusinessFundClass(): void {
	 
	 this._businessService.getQuestionDetails(sessionStorage.getItem("TRCFastTrackGrpId") ?? "").subscribe((res: any) => {
      this.qDetails = res;    
    for (let i = 0; i < this.qDetails.length; i++) {
      const resultArray = this.TRCQForms.find(
        obj => obj.questionId === this.qDetails[i].questionId)
      if (resultArray !== undefined && resultArray.answerTxt === "Y") {
        if (this.qDetails[i].revenueType) {          
            const fundclIndex =this.tRCFundClasses.findIndex(
              obj => obj.revenue_type === this.qDetails[i].revenueType
              )
            if(fundclIndex >= 0){
              this.tRCFundClasses[fundclIndex]; 
            }else{
              const trcFundClasses = new TRCFundClasses();
              trcFundClasses.revenue_type = this.qDetails[i].revenueType;              
              trcFundClasses.description = this.qDetails[i].description;
              this.tRCFundClasses.push(trcFundClasses);
            }                                                                 
              const fundclaIndex =this.tRCFundClasses.findIndex(obj => obj.revenue_type === this.qDetails[i].revenueType)
              if (fundclaIndex>=0) {
                this.tRCFundClasses[fundclaIndex]
              } else {                
                const trcFundClasses = new TRCFundClasses();
                trcFundClasses.revenue_type = this.qDetails[i].revenueType;                
                trcFundClasses.description = this.qDetails[i].description;
                this.tRCFundClasses.push(trcFundClasses);
              }          
        }
      }
    }
    sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.tRCFundClasses))
    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
if (this.errEist === false) {
	                         this.jumpToNxtPage();
       						                 
   						 }
		})
  }
jumpToNxtPage(): void {
	sessionStorage.removeItem("TRCDataErrors");
	if(this.isDisable===false){
	this.router.navigate(['/eappreg_fasttrack']);
	}
	else{
		this.router.navigate(['/eappreg_app']);
	}
	
	
	}
}



